import { createStore } from './createStore';
import { Provider } from 'react-redux';
import { jsx as _jsx } from "react/jsx-runtime";
const store = createStore();
const TimelineReduxStoreProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: children
  });
};
export default TimelineReduxStoreProvider;